import React from "react";
// import style from "./Skeleton.scss";

function SkeletonRandomJob() {
  return (
    <div className={[style.skeletonWrap].join(" ")}>
      <div className={[style.skeletonTitle].join(" ")}></div>
    </div>
  );
  return SkeletonOutput;
}

export default SkeletonRandomJob;
